import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { HeaderInfoGroup } from "@/modules/InfoGroup/models/HeaderInfoGroup";
import { RoleInfo } from "@/modules/Roles/models/RoleInfo";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  ACTION_CARD_EVENT,
  NEW_ACTION_LABEL
} from "../../../constants/ActionConstants";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";

@Component({
  name: "SearchSelect"
})
export default class SearchSelect extends Vue {
  @Prop() private label!: string;
  @Prop() private selectList!: RoleInfo[] | HeaderInfoGroup[];

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  priBtnRoundClass = STYLE_CLASSES.PRIMARY_BTN;

  SEARCH_NAME_LABEL = NEW_ACTION_LABEL.SEARCH_NAME;
  MORE_INFO = NEW_ACTION_LABEL.TYPE_AND_ENTER;

  searchName = "";
  selectedData = "";

  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];

  @Watch("selectedData")
  dataselected() {
    this.$emit(ACTION_CARD_EVENT.SELECTED_DATA, this.selectedData);
  }

  onEnter() {
    this.$emit(ACTION_CARD_EVENT.SEARCH_DATA_BY_NAME, this.searchName);
  }
}
